import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Typography from "@material-ui/core/Typography";
import Skeleton from "@material-ui/lab/Skeleton";
import JsonScreenHoc from "../../../../../../HocHelpers/JsonScreenHoc";
import findByString from "../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";

const SurveyScore = ({fieldName, globalValues, setValue, showScoring, styles, loading, screenName}) => {
    const [totalScore, setTotalScore] = useState(0);
    const currentValues = findByString(globalValues.param[screenName], `${fieldName}.answers`) || [];
    useEffect(() => {
        let score = 0;
        for (const value of currentValues) {
            if (value) {
                score = score + Number(value.weight || 1) * Number(value.points || 0)
            }
        }
        setTotalScore(score)
    }, [currentValues]);
    useEffect(() => {
        if (fieldName) {
            setValue(totalScore, `${fieldName}.scoring`);
        }
    }, [totalScore]);

    return (
        loading ? (
            showScoring ? <Skeleton animation={"wave"}/> : <></>
        ) : (
            <div style={{
                display: showScoring ? 'block' : 'none',
                background: styles.background,
                textAlign: styles.textAlign,
                padding: styles.padding
            }}>
                <Typography
                    style={{
                        padding: 5,
                        fontWeight: styles.fontWeight,
                        fontStyle: styles.fontStyle,
                        fontSize: styles.fontSize,
                        color: styles.color,
                    }}>
                    Score: {totalScore}
                </Typography>
            </div>
        )
    )
};

export default JsonScreenHoc(SurveyScore)

SurveyScore.propTypes = {
    fieldName: PropTypes.string,
    setValue: PropTypes.func,
    globalValues: PropTypes.object,
    showScoring: PropTypes.bool,
};

SurveyScore.defaultProps = {
    setValue: () => {
    },
    globalValues: {}
};